module.exports = __webpack_public_path__ + "img/character_resize_blu.b8b47d54.webp";